import React, {useCallback, useEffect, useState} from "react"
import { ComposableMap, Geographies, Geography, ZoomableGroup } from "react-simple-maps"
import {
  Button,
  Tab,
  Tabs,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip as MuiTooltip,
  IconButton,
  ButtonGroup
} from "@mui/material";
import {Tooltip} from "react-tooltip";
import { FaLock, FaLockOpen } from "react-icons/fa";
import {InfoOutlined} from "@mui/icons-material";
import {DimensionamentoService} from "../../services/DimensionamentoServices";
import Box from "@mui/material/Box";
import {useMapUfs} from "../../hooks/useMapUfs";
import {mapRegionDicts} from '../../hooks/mapRegionDicts'
import getJsonCentroid from "../../utils/getJsonCentroid";
import AutoCompleteRegions from "../../components/MapComponents/AutoCompleteRegions/AutoCompleteRegions";
import MenuMapComponent from "../../components/MapComponents/MenuMapComponent/MenuMapComponent";
import {generateColors} from "../../utils/colorScales";
import {useGeoData} from "../../hooks/useGeoData"
import {buildCityKey, sumMacroData, getScale} from "../../utils/useMapUtils";
import {useColorGradient} from "../../hooks/useColorGradient";

export default function MapUfs({beneficiariosDemo, tableSetter, regionInputDataSetter, selectedCity, setSelectedVariable, search, setSearch, setSelectedState, selectedState, subTitle}) {
  const [foundsCity, setFoundsCity] = React.useState([]);

  const [debouncedSearch, setDebouncedSearch] = React.useState("")
  const [loadedFeatures, setLoadedFeatures] = useState([])

  const [sortOption, setSortOption] = useState("default");
  const [listRegionStates, setListRegionStates] = useState(mapRegionDicts["Norte".toLowerCase()])
  const [colors, setColors] = React.useState({});

  const [allStates, setAllStates] = React.useState([])

  const [micro, setMicro] = useState([])
  const [macro, setMacro] = useState([])

  const [selectedRegion, setSelectedRegion] = useState("Município")
  const [scaleType, setScaleType] = useState('linear');

  const [loading, setLoading] = React.useState(true);
  const [isTableLocked, setIsTableLocked] = React.useState(true)


  const { geoUrl, jsonState, allCities: allMapCities, loadStateGeoJson, loadRegionGeoJson } = useGeoData();

  const handleRegionData = useMapUfs(selectedRegion, selectedState, regionInputDataSetter,
    beneficiariosDemo, allMapCities, macro, micro, setMacro, setMicro,  sortOption)


  const stateLegendGradient = useColorGradient(allMapCities, beneficiariosDemo, sortOption, scaleType)

  const showGradient = stateLegendGradient ? stateLegendGradient() : null


  const getMunicipalitiesWithData = useCallback(() => {
    if (!allMapCities.length || !beneficiariosDemo.valuesCity.length) return 0;

    let countWithData = 0;
    
    for (let i = 0; i < beneficiariosDemo.valuesCity.length; i++) {
      let cidade = beneficiariosDemo.valuesCity[i][0];
      const cidadeSemUF = cidade.slice(0, -5);

      if (allMapCities.includes(cidadeSemUF)) {
        const valor = sumMacroData(beneficiariosDemo.valuesCity[i]);
        if (valor > 0) {
          countWithData++;
        }
      }
    }
    
    return countWithData;
  }, [allMapCities, beneficiariosDemo.valuesCity]);




  useEffect(() => {
    handleRegionData()
  }, [handleRegionData]);

  const changeState = useCallback(async (value) => {
    setLoading(true);

    setMicro([])
    setMacro([])

    if (sortOption === 'default'){
      setSelectedState(value)

      await loadStateGeoJson(value)

    } else if (sortOption === 'region'){
      setSelectedState(value)
      setListRegionStates(mapRegionDicts[value.toLowerCase()])
      await loadRegionGeoJson(mapRegionDicts[value.toLowerCase()])
    }


    setLoading(false);
  }, [setSelectedState, sortOption,  loadRegionGeoJson, loadStateGeoJson]);



  const fetchRegionData = useCallback(async (value) => {
    const response = sortOption === 'default' ? await DimensionamentoService.getSearchType(value)
      : await DimensionamentoService.getSearchTypeWithUF(value)

    if (!response) {return}
    switch (selectedRegion) {

      case "Cidade":
        break
      case "Macro-Região":
        return response.macroRegion

      case "Micro-Região":
        return response.microRegion

      default:
        return response.city
    }
  }, [selectedRegion, sortOption])
  
  useEffect(() => {
    async function loadInitialData() {
      if (beneficiariosDemo.valuesCity.length === 0) return;
      
      setLoading(true);
      
      let states = []
      if (sortOption === 'default'){
        beneficiariosDemo.valuesCity.forEach((city) => {
          if (Array.isArray(city) && city.length > 0 && typeof city[0] === 'string') {
            const state = city[0].slice(-2);
            if (!states.includes(state)) {
              states.push(state);
            }
          }
        });
        states.sort()
        if (states.length > 0) {
          setAllStates(states)
          changeState(states[0]);
          const firstState = states[0];
          setSelectedState(firstState)

          await loadStateGeoJson(firstState)
        }
      }
      else if (sortOption === 'region'){
        beneficiariosDemo.valuesCity.forEach((city) => {
          if (!states.includes(city[0].slice(-2))) {
            states.push(city[0].slice(-2));
          }
        });
        states.sort()


        if (states.length > 0){
          setAllStates(['Norte', 'Nordeste', 'Centro-Oeste','Sul', 'Sudeste' ])
          const initialState = 'Norte'
          setSelectedState(initialState)
          await loadRegionGeoJson(mapRegionDicts[initialState.toLowerCase()])
        }
      }
      
      setLoading(false);
    }
    
    loadInitialData();
  }, [beneficiariosDemo.valuesCity, changeState, loadStateGeoJson, loadRegionGeoJson, setSelectedState, sortOption]);

  useEffect(() => {
    if (allMapCities.length > 0 && beneficiariosDemo.valuesCity.length > 0) {
      let dicionarioCidades = {};

      for (let i = 0; i < beneficiariosDemo.valuesCity.length; i++) {
        const cidadeData = beneficiariosDemo.valuesCity[i];

        if (!Array.isArray(cidadeData) || cidadeData.length === 0) continue;


        const cidadeComUF = cidadeData[0];
        if (typeof cidadeComUF !== 'string') continue;

        const estadoCidade = cidadeComUF.slice(-2);
        if (sortOption === 'default' && estadoCidade !== selectedState) continue;

        const cityKey = buildCityKey(cidadeComUF, sortOption)

        if (allMapCities.includes(cityKey)) {
          dicionarioCidades[cityKey] = sumMacroData(cidadeData);
        }
      }
      
      const cidadesOrdenadas = Object.entries(dicionarioCidades).sort((a, b) => b[1] - a[1]);
      
      if (cidadesOrdenadas.length === 0) {
        setColors({});
        return;
      }
      
      const redScale = generateColors(cidadesOrdenadas, scaleType);
      setColors(redScale);
    }
  }, [allMapCities, beneficiariosDemo.valuesCity, scaleType, sortOption, selectedState]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(search)
    }, 20)

    return () => clearTimeout(timeout)
  }, [search]);

  useEffect(() => {
    if (getMunicipalitiesWithData() <= 1 && scaleType !== 'linear') {
      setScaleType('linear');
    }
  }, [getMunicipalitiesWithData, scaleType]);


  useEffect(() => {
    if (!debouncedSearch || loadedFeatures.length === 0) return;

    const buildFullCityName = (feature) =>
      `${feature.properties.name} - ${feature.properties.uf}`

    const handleMunicipioSearch = () => {
      const matchedCities = loadedFeatures.filter((feature) =>
        buildFullCityName(feature).toLowerCase().includes(debouncedSearch.toLowerCase())
      );

      const formattedCities = sortOption === 'region'
        ? matchedCities.map(buildFullCityName)
        : matchedCities.map((feature) => feature.properties.name)

      setFoundsCity([...new Set(formattedCities)])
    };

    const handleRegionSearch = async () => {
      const regionCities = await fetchRegionData(debouncedSearch)
      if (!regionCities) return

      const regionSet = new Set(regionCities.map((city) => city.toLowerCase()))

      const matchedCities = loadedFeatures.filter((feature) => {
        const name = feature?.properties?.name
        const uf = feature?.properties?.uf

        if (!name) return false

        const cityName = sortOption === 'region'
          ? `${name.toLowerCase()} - ${(uf || "").toLowerCase()}`
          : name.toLowerCase()

        return regionSet.has(cityName)
      });

      const formattedCities = matchedCities.map((feature) =>
        sortOption === 'region'
          ? `${feature.properties.name} - ${feature.properties.uf}`
          : feature.properties.name
      );

      setFoundsCity([...new Set(formattedCities)]);
    };

    if (selectedRegion === "Município") {
      handleMunicipioSearch()
    } else {
      handleRegionSearch()
    }
  }, [debouncedSearch, loadedFeatures, selectedRegion, fetchRegionData, sortOption]);

  useEffect(() => {
    const loadFeatures = async () => {
      if (!geoUrl) return;

      if (Array.isArray(geoUrl)) {
        const responses = await Promise.all(
          geoUrl.map((url, index) =>
            fetch(url)
              .then((res) => res.json())
              .then((data) =>
                data.features.map((feature) => ({
                  ...feature,
                  properties: {
                    ...feature.properties,
                    uf: listRegionStates[index],
                  },
                }))
              )
          )
        );
        setLoadedFeatures(responses.flat())
      } else {
        const response = await fetch(geoUrl).then((res) => res.json())
        setLoadedFeatures(response.features)
      }
    };

    loadFeatures()
  }, [geoUrl, listRegionStates])

  const handleSortChange = (newSortOption) => {
    setSortOption(newSortOption);
  };


  return (
    <div className="flex flex-col w-full h-full shadow-xl border rounded-lg p-5">
      <Tooltip className="z-50" id="map-tooltip"/>
      <div className="w-full">
        <p className="text-xl font-medium text-center">
          {subTitle ? subTitle : "Mapa de Distribuição por "}
          <span
          className="text-emerald-700">{sortOption === 'default' ? "Estado" : "Região"}</span></p>
        <Box className="flex gap-2 w-full xl:w-auto justify-center items-center mx-2">
          <ButtonGroup
            variant="outlined"
            size="small"
            className="w-full xl:w-auto p-2  text-sm font-light"
          >
            <Button
              onClick={() => {
                handleSortChange('default')
              }}
              variant={sortOption === "default" ? "contained" : "outlined"}
              sx={{
                backgroundColor:
                  sortOption === "default" ? "#10b981" : "transparent",
                color: sortOption === "default" ? "white" : "#10b981",
                borderColor: "#10b981",
                textTransform: "none",
                fontWeight: 500,
                flex: {xs: 1, xl: "none"},
                "&:hover": {
                  backgroundColor:
                    sortOption === "default" ? "#059669" : "#dcfce7",
                  borderColor: "#10b981",
                },
              }}
            >Estado</Button>
            <Button
              onClick={() => {
                handleSortChange('region')
              }}
              variant={sortOption === "region" ? "contained" : "outlined"}
              sx={{
                backgroundColor:
                  sortOption === "region" ? "#10b981" : "transparent",
                color: sortOption === "region" ? "white" : "#10b981",
                borderColor: "#10b981",
                textTransform: "none",
                fontWeight: 500,
                flex: {xs: 1, xl: "none"},
                "&:hover": {
                  backgroundColor:
                    sortOption === "region" ? "#059669" : "#dcfce7",
                  borderColor: "#10b981",
                },
              }}
            >Região</Button>
          </ButtonGroup>
        </Box>
        <div className="flex flex-col 2xl:flex-row w-full justify-center items-center gap-y-4">
          <div className="w-full p-2 pt-4 flex items-center justify-center">
            <div className="w-full">
              <AutoCompleteRegions selectedCity={selectedCity} selectedRegion={selectedRegion}
                                   setSearch={setSearch} search={search} sortOption={sortOption}/>
            </div>
            <div className='flex flex-row w-auto'>
              <MenuMapComponent
                setSelectedRegion={setSelectedRegion}
                setSelectedVariable={setSelectedVariable}
              />
              <div
                title={isTableLocked ? "Mostrar apenas regiões referentes à pesquisa" : "Mostrar todas as regiões cadastradas"}>
                <Button
                  onClick={(() => {
                    tableSetter(!isTableLocked)
                    setIsTableLocked(!isTableLocked)
                  })}
                >
                  {

                    isTableLocked ?
                      <FaLock className="mx-2 md:text-3xl text-xl text-emerald-700 hover:text-emerald-800 cursor-pointer"/>
                      : <FaLockOpen className="mx-2 md:text-3xl text-xl text-emerald-600 cursor-pointer scale-110"/>
                  }
                </Button>
              </div>
            </div>
          </div>

          <div className="flex w-full 2xl:w-auto items-center justify-end pt-4 ">
            <FormControl sx={{width: '100%', marginX: '8px'}} >
              <InputLabel
                id="scale-type-label"
                sx={{
                  color: "#059669",
                  "&.Mui-focused": {color: "#059669"},
                  fontSize: "0.75rem"
                }}
              >
                Escala
              </InputLabel>
              <Select
                variant="outlined"
                labelId="scale-type-label"
                label="Escala"
                value={scaleType}
                onChange={(event) => setScaleType(event.target.value)}
                size="small"
                MenuProps={{
                  disableScrollLock: true,
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {borderColor: "#a7f3d0"},
                    "&:hover fieldset": {borderColor: "#059669"},
                    "&.Mui-focused fieldset": {borderColor: "#059669"},
                  },
                  "& .MuiSelect-select": {
                    color: "#065f46",
                    fontSize: "0.75rem"
                  },
                }}
              >
                <MenuItem value="linear">Simples</MenuItem>
                <MenuItem
                  value="quantile"
                  disabled={getMunicipalitiesWithData() <= 1}
                  sx={{
                    opacity: getMunicipalitiesWithData() <= 1 ? 0.5 : 1,
                    "&.Mui-disabled": {
                      color: "#9ca3af"
                    }
                  }}
                >
                  {getMunicipalitiesWithData() <= 1 ? 'Grupos*' : 'Grupos'}
                </MenuItem>
                <MenuItem
                  value="log"
                  disabled={getMunicipalitiesWithData() <= 1}
                  sx={{
                    opacity: getMunicipalitiesWithData() <= 1 ? 0.5 : 1,
                    "&.Mui-disabled": {
                      color: "#9ca3af"
                    }
                  }}
                >
                  {getMunicipalitiesWithData() <= 1 ? 'Log*' : 'Log'}
                </MenuItem>
                <MenuItem
                  value="zscore"
                  disabled={getMunicipalitiesWithData() <= 1}
                  sx={{
                    opacity: getMunicipalitiesWithData() <= 1 ? 0.5 : 1,
                    "&.Mui-disabled": {
                      color: "#9ca3af"
                    }
                  }}
                >
                  {getMunicipalitiesWithData() <= 1 ? 'Desvio*' : 'Desvio'}
                </MenuItem>
              </Select>
            </FormControl>
            <MuiTooltip
              title={
                <div>
                  <strong>Tipos de escala:</strong><br/>
                  • Simples: Baseada no valor máximo<br/>
                  • Grupos: Divide em 5 grupos iguais<br/>
                  • Log: Escala logarítmica<br/>
                  • Desvio: Baseada no desvio padrão
                  {getMunicipalitiesWithData() <= 1 && <><br/><em>* Requer 2+ municípios com dados</em></>}
                </div>
              }
              placement="top"
              arrow
            >
              <IconButton
                size="small"
                sx={{
                  ml: 0.5,
                  color: "#059669",
                  "&:hover": {
                    color: "#047857",
                    backgroundColor: "rgba(5, 150, 105, 0.04)"
                  }
                }}
              >
                <InfoOutlined fontSize="small"/>
              </IconButton>
            </MuiTooltip>
          </div>

        </div>
        <hr className="h-px bg-gray-200 border-0 mt-2 dark:bg-gray-200"/>
      </div>
      <Box sx={{display: 'flex', justifyContent: 'center'}}>
        <Tabs
          value={selectedState}
          onChange={(event, value) => changeState(value)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            maxWidth: '100%',
            '& .MuiTabs-indicator': {
              backgroundColor: '#005734',
            },
            '& .MuiTab-root': {
              color: '#005734',
              whiteSpace: 'nowrap',
              minWidth: 72,
            },
            '& .Mui-selected': {
              color: '#007B49 !important',
            },
          }}
        >
          {allStates.map((state) => (
            <Tab key={state} label={state} value={state} />
          ))}
        </Tabs>
      </Box>


      {loading ? (
        <Box
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
        >
          <CircularProgress />
        </Box>
      ) : (
        geoUrl !== "" && Object.keys(jsonState).length > 0 && (
          <>
            <ComposableMap
              projectionConfig={{
                scale: getScale(jsonState, selectedState),
                center: jsonState['centroid'] ? jsonState['centroid']['coordinates'] : getJsonCentroid(jsonState['features'])
              }}
              style={{
                width: "100%",
                height: "100%",
                transform: "scaleY(0.88)",
              }}
            >
              <ZoomableGroup
                center={jsonState['centroid'] ? jsonState['centroid']['coordinates'] : getJsonCentroid(jsonState['features'])}>
                <Geographies geography={jsonState['features']}>
                  {({ geographies }) =>
                    geographies.map((geo) => {
                      const cityKey = sortOption === 'region' ? `${geo.properties.name} - ${geo.properties.uf}` : geo.properties.name;
                      const colorValue = colors && colors[cityKey];

                      let fill;

                      if (colorValue !== undefined) {
                        if (isNaN(colorValue)) {
                          fill = "#000000";
                        } else {
                          fill = `rgb(${colorValue}, 0, 0)`;
                        }
                      } else {
                        fill = "#007b49";
                      }

                      if (foundsCity.length > 0 && search !== "" && !foundsCity.includes(cityKey)) {
                        fill = "#D6D6DA";
                      }

                      return (
                        <Geography
                          className="cursor-pointer"
                          key={geo.rsmKey}
                          geography={geo}
                          style={{
                            default: { fill, stroke: "#FFFFFF", strokeWidth: 0.3},
                            hover: { fill: "#009460", mixBlendMode: "multiply", stroke: "#FFFFFF", strokeWidth: 0.3},
                            pressed: { fill: "#E42", stroke: "#FFFFFF", strokeWidth: 0.3 },
                          }}
                          stroke="#00000"
                          strokeWidth={0.25}
                          data-tooltip-id="map-tooltip"
                          data-tooltip-content={geo.properties.name}
                        />
                      );
                    })
                  }
                </Geographies>
              </ZoomableGroup>
            </ComposableMap>
            <div>
              <div className="flex flex-wrap justify-center sm:justify-between px-4 sm:px-8 md:px-20 gap-4">
                {allMapCities.length > 0 && beneficiariosDemo.valuesCity.length > 0 && showGradient && (
                  <div className="w-full flex flex-col items-center mt-4">
                    <div className="w-full  px-4">
                      <div
                        className="h-3 w-full rounded-full"
                        style={{ background: showGradient }}
                      />
                      <div className="flex justify-between text-sm text-gray-700 mt-1 px-1">
                        <span>
                          Baixa concentração
                        </span>
                        <span> 
                           Alta concentração
                        </span>
                      </div>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </>
        ))}

    </div>
  )
}
